export default "__VITE_ASSET__bc92dc82__"